import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMobileMenuOpen } from '../../Actions/Navigation.action';
import MobileNavigationLanguageSwitcher from './MobileNavigationLanguageSwitcher';
import SideMenu from './../SideMenu';
import { translate } from '../../Services/translation';
import Icon from '../IconBase/Icon';
import(`./styles/${window.__litium.themeName}.scss`);

const NavigationMobile = () => {
  const dispatch = useDispatch();
  const {
    mobileMenuOpen,
    contentLinks,
    logoUrl,
    logoLinkUrl,
    languageSwitcher,
    topLinkList,
    topRightLinkList,
  } = useSelector((state) => state.navigation);
  const [currentLink, setCurrentLink] = useState();
  const [previousLink, setPreviousLink] = useState();

  useEffect(() => {
    if (mobileMenuOpen) {
      setCurrentLink(null);
    }
  }, [mobileMenuOpen]);

  const onLinkClick = (link) => {
    link.previousLink = previousLink;
    setPreviousLink(currentLink);
    setCurrentLink(link);
  };

  const onBackClick = () => {
    setPreviousLink(previousLink?.previousLink);
    setCurrentLink(previousLink);
  };

  const links = currentLink?.links ?? contentLinks;

  const headerRef = (
    <>
      {!currentLink && (
        <a className="side-menu__logo" href={logoLinkUrl}>
          <img src={logoUrl} alt="Logo" />
        </a>
      )}
      {currentLink && (
        <div className="navigation-mobile__back" onClick={onBackClick}>
          <Icon iconCode="arrow_back" />
          <span>{translate('general.back')}</span>
        </div>
      )}
    </>
  );

  return (
    <SideMenu
      from="left"
      id="navigation-mobile"
      open={mobileMenuOpen}
      onClosed={() => dispatch(setMobileMenuOpen(false))}
      headerRef={headerRef}
      className="side-menu--navigation-mobile"
      closeButton={
        <div className="side-menu__close-button-container">
          <Icon iconCode="close" />
        </div>
      }
      languageSwitcher={
        <MobileNavigationLanguageSwitcher
          currentChannel={languageSwitcher.currentChannel}
          otherChannels={languageSwitcher.otherChannels}
        />
      }
    >
      <div className="navigation-mobile__links">
        {links.map((link, key) => (
          <Fragment key={key}>
            {link.name && (
              <MobileNavigationItem
                link={link}
                onClick={onLinkClick}
                boldLink={link.boldLinksMobile}
                noCaret={currentLink !== null}
              />
            )}
            {currentLink !== null &&
              link.links.map((subLink, key) => (
                <MobileNavigationItem
                  link={subLink}
                  key={key}
                  onClick={onLinkClick}
                  boldLink={subLink.boldLinksMobile}
                />
              ))}
          </Fragment>
        ))}
        {currentLink === null &&
          topLinkList.map((link, key) => (
            <MobileNavigationItem
              key={key}
              link={link}
              boldLink={true}
              noCaret={true}
            />
          ))}
        {currentLink === null &&
          topRightLinkList &&
          topRightLinkList.map((link, key) => (
            <MobileNavigationItem
              key={key}
              link={link}
              boldLink={true}
              noCaret={true}
            />
          ))}
      </div>
    </SideMenu>
  );
};

const MobileNavigationItem = ({ link, boldLink, onClick, noCaret }) => (
  <div
    className={`navigation-mobile__link ${
      boldLink ? 'navigation-mobile__link--bold' : ''
    }`}
  >
    <a href={link.url}>{link.name}</a>
    {link.links?.length > 0 && onClick && !noCaret && (
      <div
        className="navigation-mobile__next-level-button"
        onClick={() => onClick && onClick(link)}
      >
        <Icon
          iconCode={
            window.__litium.themeName == 'WTG'
              ? 'arrow_forward'
              : 'chevron_right'
          }
        />
      </div>
    )}
  </div>
);

export default NavigationMobile;
